import { createSlice } from '@reduxjs/toolkit'
import { cacheCallBegan } from '../cache'
import { superFeedInitialState as initialState } from '../initialState/superFeedEventsState'
import { apiCallBegan } from '../api'
import { getStatusText } from '../../utilities/statusMap'
import { onFilterByUpdate, onSortCriteriaUpdate, onResetTotal, onPageChange, onParamsUpdate, onViewChange } from '../filters'
//setCurrentPage
// import { on } from 'ace-builds-internal/config'

const eventsFailed = (events, action) => {
  if(action && action.payload && action.payload === "Invalid customer id") {
    events.loading = false;
    events.userMsg = null
    events.statusCode = null  
  } else {
    // console.log("Super Feed API failed...")
    events.loading = false;
    events.userMsg = "Could not load Super Feed Events!!"
    events.statusCode = 500  
  }
}

const slice = createSlice({
  name: 'superFeedEvents',
  initialState: initialState,
  reducers: {
    onSuccess: (events, action)=> {
      events.filters = action.payload.filters;
    },
    eventsRequested: (events) => {
      events.loading = true
    },
    // TODO: Analyze the impact and combine eventsReceived reducers
    eventsReceived: (events, action) => {
      // console.log("SF eventsReceived : ", action.payload, events.totalSize);
      const { data } = action.payload.response
      const mappedRecords = data.map(record => {
        if (record.userAction === "Pending") {
          let dt = new Date(record.detectionTime);
          dt.setMinutes(dt.getMinutes() + 5)
          if (new Date() >= dt)
            record.userAction = "Close";
        }
        record = setEventStatus(record);
        return record;
      })
      let noOfRows = mappedRecords.length;
      mappedRecords.splice(events.pageSize,1);
      if (!(events.list instanceof Array)) events.list = []; 
      events.list.push(...mappedRecords);
      events.totalSize = events.list.length;
      // console.log("No of rows fetched : ", noOfRows, mappedRecords.length, events);
      // if(events.calculateTotal) {
      //   // console.log("Calculating total size of super feed events : ", events.calculateTotal, events.pageNo);
      //   events.totalSize = events.list.length;
      // } else {
      //   // console.log("Not calculating total size of super feed events", events.calculateTotal, events.pageNo);
      //   events.calculateTotal = true;
      // }
      // console.log("SF events processed : ", events.totalSize);
      events.isLastPage = noOfRows <= events.pageSize;
      // console.log("pageNo: ", events.pageNo);
      // _totalRecords = mappedRecords.length
      events.loading = false
      events.switchToChart = events.switchToChartOnLogin && mappedRecords.length <= 0 ;
      events.switchToChartOnLogin = false
    },
    eventReceived: (events, action) => {
      events.loading = false
      events.selected = setEventStatus(action.payload.response);
    },
    eventsRequestFailed: (events, action) => {
      eventsFailed(events, action)
    },
    eventByIdRequested: (events, action) => {
      events.selectedEvent = initialState.selectedEvent;
      events.selectedEventLoading = true;
    },
    eventByIdSuccess: (events, action) => {
      events.selectedEventLoading = false;
      events.selectedEvent = action.payload.response.data ? action.payload.response.data : {};
      if (events.selectedEvent) {
        events.selectedEvent = setEventStatus(events.selectedEvent);
      }
    },
    eventByIdFailed: (events, action) => {
      events.selectedEventLoading = false;
      events.selectedEvent = initialState.selectedEvent;
    },
    screenshotRequested: (events, action) => {
      events.screenshotsLoading[action.reducerData.id] = true;
    },
    screenshotSuccess: (events, action) => {
      let response = action.payload.response.data.length > 0 ? action.payload.response.data[0] : ''; 
      events.screenshots = { ...events.screenshots, [action.reducerData.id]: response.data ? response.data : '' };
      events.screenshotsLoading = { ...events.screenshotsLoading, [action.reducerData.id]: false };
    },
    screenshotFailure: (events, action) => {
      events.screenshotsLoading = { ...events.screenshotsLoading, [action.reducerData.id]: false };
    },
    markedScreenshotRequested: (events, action) => {
      events.markedScreenshotsLoading[action.reducerData.id] = true;
    },
    markedScreenshotSuccess: (events, action) => {
      let response = action.payload.response.data.length > 0 ? action.payload.response.data[0] : '';
      events.markedScreenshots = { ...events.markedScreenshots, [action.reducerData.id]: response.data ? response.data : '' };
      events.markedScreenshotsLoading = { ...events.markedScreenshotsLoading, [action.reducerData.id]: false };
    },
    markedScreenshotFailure: (events, action) => {
      events.markedScreenshotsLoading = { ...events.markedScreenshotsLoading, [action.reducerData.id]: false };
    },
    htmlRequested: (events, action) => {
      events.htmlLoading[action.reducerData.id] = true;
    },
    htmlSuccess: (events, action) => {
      let response = action.payload.response.data.length > 0 ? action.payload.response.data[0] : '';
      events.html = { ...events.html, [action.reducerData.id]: response.data ? response.data : '' };
      events.htmlLoading = { ...events.htmlLoading, [action.reducerData.id]: false };
    },
    htmlFailure: (events, action) => {
      events.htmlLoading = { ...events.htmlLoading, [action.reducerData.id]: false };
    },
    onSuperFeedFilterUpdate: (events, action)=> {
      events.filterBy = action.payload.filters;
    },
    onSuperFeedSortCriteriaUpdate: (events, action) => {
      events.sortBy = action.payload.sortingCriteria;
    },
    onFilterParamsUpdate: (events, action) => {
      events.params = action.payload.params;
    },
    onCurrentPageChange: (events, action) => {
      // set the currentPageNumber
      let { pageNo, maxPageNo } = action.payload;
      events.maxPageNo = maxPageNo;
      events.pageNo = pageNo;
    },
    onSFResetTotal: (events, action) => {
      // console.log("Resetting the total size of super feed events");
      events.totalSize = 0;
      events.list = [];
      // events.maxPageNo = 1;
      // events.calculateTotal = true;
      events.pageNo = 1;
    },
    resetModalSuccess: (events) => {
      events.statusCode = null;
    },
    // setSwitchToChart : (events, action) => {
    //   events.switchToChartOnLogin = false;
    //   events.switchToChart = false;
    // },
    addThreatIntelRequested: (events) => {
      events.threatIntel.loading = true;
    },
    addThreatIntelReceived: (events, action) => {
      events.threatIntel.loading = false;
      events.threatIntel.status = 200;
      events.threatIntel.userMsg = "";
    },
    addThreatIntelFailed: (events, action) => {
      let errors = []
      if(typeof action.payload.errors !== 'undefined' && action.payload.errors.length > 0)
        errors = action.payload.errors;
      else if(typeof action.payload === 'string')
        errors.push({desc: action.payload});

      events.threatIntel.loading = false;
      events.threatIntel.status = 500;
      events.threatIntel.userMsg = errors.length > 0 ? errors[0].desc : "Failed to add Threat Intelligence";
    },
    setStatusCode: (events, action) => {
      events.statusCode = action.payload;
      events.threatIntel.status = action.payload;
    },
    setViewType: (events, action) => {
      events.superFeedView.currentView = typeof action.payload["viewType"] === 'string' ? action.payload.viewType : events.superFeedView.default;
    }
  }
})

export const {
  eventsReceived,
  resetModalSuccess,
  eventReceived,
  setViewType,
  eventsRequested,
  threatsDetectedRequested,
  eventsRequestFailed,
  onSuccess,
  // setSwitchToChart,
  addThreatIntelRequested,
  addThreatIntelReceived,
  addThreatIntelFailed,
  setStatusCode,
  getQueryParamStr,
  eventByIdRequested,
  eventByIdSuccess,
  eventByIdFailed,
  screenshotRequested,
  screenshotSuccess,
  screenshotFailure,
  markedScreenshotRequested,
  markedScreenshotSuccess,
  markedScreenshotFailure,
  htmlRequested,
  htmlSuccess,
  htmlFailure,
  onSuperFeedFilterUpdate,
  onSuperFeedSortCriteriaUpdate,
  onFilterParamsUpdate,
  onSFResetTotal,
  onCurrentPageChange
} = slice.actions;

export default slice.reducer;

export const setCurrentView=(viewType)=>{
  return onViewChange({viewType: viewType,
    onSuccess: setViewType.type
  });
}

export const setCurrentPage=(pageNo, maxPageNo)=>{
  return onPageChange({pageNo: pageNo,
    maxPageNo: maxPageNo,
    onSuccess: onCurrentPageChange.type
  });
}

export const resetSuperFeedEventsTotal=()=>{
  // console.log("Action to reset the total size of super feed events");
  return onResetTotal({totalSize: 0,
    onSuccess: onSFResetTotal.type
  });
}

export const setSuperFeedFiltersInStore=(filters)=>{
  return onFilterByUpdate({filterBy: filters,
    onSuccess: onSuperFeedFilterUpdate.type
  });
}

export const setSuperFeedSortCriteriaInStore=(sortCriteria)=>{
  return onSortCriteriaUpdate({sortCriteria,
    onSuccess: onSuperFeedSortCriteriaUpdate.type
  });
}

export const setSuperFeedParametersInStore=(params)=>{
  return onParamsUpdate({params,
    onSuccess: onFilterParamsUpdate.type
  });
}

export const loadSuperFeedEvents = (pageNo, pageSize, customerId, filterBy, sortBy, params) => {

  let reqParams = {};
  // if (customerId) {
  //   reqParams.custId = customerId;
  // }
  if (!isNaN(pageNo) && pageNo >= 0) {
    reqParams.pageNo = pageNo;
  } else {
    reqParams.pageNo = 1;
  }
  if(!isNaN(pageSize) && pageSize >= 0) {
    reqParams.pageSize = pageSize + 1;
  } else {
    reqParams.pageSize = 21;
  }
  // console.log("loadSuperFeedEvents called: ", pageNo, pageSize, customerId, filterBy, sortBy, params);
  if (filterBy && filterBy instanceof Object && Object.keys(filterBy).length > 0) {
    reqParams.filterBy = Object.keys(filterBy).filter(key => !(key === 'rrURLYN' || key === 'incldFP')).join(',');
    params = Object.entries(filterBy).map(([key, value]) => ({ key, value }));
    // console.info("Filters provided for super feed events loading", reqParams.filterBy);
    // console.info("Params provided for super feed events loading", params);
  } else {
    // console.info("No filters provided for super feed events loading, using default filters");
  }

  if( sortBy && sortBy.length > 0) {
    reqParams.sortBy = sortBy.join(',');
    // console.log("SortBy provided for super feed events loading", reqParams.sortBy);
  } else {
    // console.info("No sortBy provided for super feed events loading, using default sortBy");
  }
  if (params && params.length > 0) {
    params.forEach(param => {
      if (param.key && typeof param.value !== 'undefined' && reqParams[param.key] === undefined) {
        reqParams[param.key] = param.value;
      } else {
        console.warn(`Invalid parameter provided for super feed events loading: ${param.key}=${param.value}`);
      }
    });
  }

  return (dispatch, getState) => {
    return dispatch(apiCallBegan({
      urlPath: 'super-feed',
      method: 'GET',
      filters: reqParams,
      onStart: eventsRequested.type,
      onSuccess: eventsReceived.type,
      onError: eventsRequestFailed.type,
    }))
  }
}

export const loadEventById = (eventId, customerId) => (dispatch) => {
  return dispatch(apiCallBegan({
    urlPath: `super-feed/${eventId}`,
    method: 'GET',
    onStart: eventByIdRequested.type,
    onSuccess: eventByIdSuccess.type,
    onError: eventByIdFailed.type,
  }))
}

export const loadScreenshotResized = (container, filepath, blobName, type, eventId ) => (dispatch) => {
  return dispatch(apiCallBegan({
    baseUrl : process.env.REACT_APP_API_BASE_URL_NO_VERSION,
    urlPath: `storage/blob`,
    method: 'GET',
    filters : {
      c : container,
      p : filepath,
      b : blobName,
      t : type
    },
    onstart : screenshotRequested.type,
    onSuccess: screenshotSuccess.type,
    onError: screenshotFailure.type,
    reducerData: { id: eventId }
  }))
}

export const loadScreenshotMarked = (container, filepath, blobName, type, eventId ) => (dispatch) => {
  return dispatch(apiCallBegan({
    baseUrl : process.env.REACT_APP_API_BASE_URL_NO_VERSION,
    urlPath: `storage/blob`,
    method: 'GET',
    filters : {
      c : container,
      p : filepath,
      b : blobName,
      t : type
    },
    onstart : markedScreenshotRequested.type,
    onSuccess: markedScreenshotSuccess.type,
    onError: markedScreenshotFailure.type,
    reducerData: { id: eventId }
  }))
} 

export const loadHTML = (container, filepath, blobName, type, eventId) => (dispatch) => {
  return dispatch(apiCallBegan({
    baseUrl: process.env.REACT_APP_API_BASE_URL_NO_VERSION,
    urlPath: `storage/blob`,
    method: 'GET',
    filters: {
      c: container,
      p: filepath,
      b: blobName,
      t: type
    },
    onstart: htmlRequested.type,
    onSuccess: htmlSuccess.type,
    onError: htmlFailure.type,
    reducerData: { id: eventId }
  }))
}

const setEventStatus = (event) => {
  if (!event.status) {
    event.status = getStatusText(event);
  }
  return event;
}
